document.addEventListener('DOMContentLoaded', () => {
	let currentImageIndex = 0;
	let isAnimating = false;



	const cards = document.querySelectorAll('.guide-card');
	const nextArrow = document.querySelector('.next-arrow');
	const prevArrow = document.querySelector('.prev-arrow');
	const imageTags = document.querySelectorAll('.guide-card-collapsable-image');
	const capButtons = document.querySelectorAll('.cap-button');
	const instructions = document.querySelectorAll('.instruction');
	const closeSectionBtn = document.querySelectorAll('.close-section-btn');
	const instructionsContainer = document.querySelector('.instructions-container');

	// Function to calculate and set the optimal height for the instructions container
	const updateInstructionsContainerHeight = () => {
		if (!instructionsContainer || instructions.length === 0) return;
		
		let maxHeight = 0;
		
		// Temporarily make all instructions visible to measure their heights
		instructions.forEach(instruction => {
			const originalTransform = instruction.style.transform;
			const originalTransition = instruction.style.transition;
			
			// Make instruction visible for measurement
			instruction.style.transition = 'none';
			instruction.style.transform = 'translateX(0)';
			instruction.style.position = 'relative';
			instruction.style.opacity = '0';
			
			// Force reflow
			void instruction.offsetHeight;
			
			// Get the natural height
			const height = instruction.offsetHeight;
			maxHeight = Math.max(maxHeight, height);
			
			// Restore original styles
			instruction.style.transform = originalTransform;
			instruction.style.transition = originalTransition;
			instruction.style.position = 'absolute';
			instruction.style.opacity = '';
		});
		
		// Set the container height to accommodate the tallest instruction
		instructionsContainer.style.height = `${maxHeight}px`;
	};

	const onClickGuideCard = (e) => {
		const guideCardId = e.getAttribute('data-guide-id');
		const sectionId = e.getAttribute('data-section-id');
		const isCollapsable = e.getAttribute('data-collapsable') === 'true';
		const guideCard = document.getElementById(`collapsableGuideCard-${guideCardId}`);

		const collapsableCollectionContainer = document.getElementById(`rowScrollerCollapsableSection-${sectionId}`);

		if(isCollapsable && collapsableCollectionContainer){
			const elementRect = collapsableCollectionContainer.getBoundingClientRect();
			const offsetTop = elementRect.top + window.pageYOffset - 100; // 100px from top
			window.scrollTo({
				top: offsetTop,
				behavior: 'smooth'
			});
		}


		if(!guideCard) return;

		guideCard.classList.toggle('active');
		
		// Update container height when guide card is opened
		if (guideCard.classList.contains('active')) {
			// Use setTimeout to ensure the card is fully expanded before measuring
			setTimeout(updateInstructionsContainerHeight, 100);
		}
	}

	// Consistent linear sliding animation function
	const slideToIndex = (targetIndex) => {
		if (isAnimating) return;
		
		const from = currentImageIndex;
		const to = targetIndex;
		const goBackward = from > to;
		
		if (from === to) return;
		
		isAnimating = true;
		
		// Add animating class to prevent hover effects during transition
		imageTags.forEach(img => img.classList.add('animating'));
		
		// ==== Prepare incoming slides (NO transition) ====
		imageTags[targetIndex].style.transition = 'none';
		imageTags[targetIndex].style.transform = goBackward ? 'translateX(-100%)' : 'translateX(100%)';
		
		instructions[targetIndex].style.transition = 'none';
		instructions[targetIndex].style.transform = goBackward ? 'translateX(-100%)' : 'translateX(100%)';
		
		// Force reflow
		void imageTags[targetIndex].offsetWidth;
		void instructions[targetIndex].offsetWidth;
		
		// Re-enable transition
		imageTags[targetIndex].style.transition = '';
		instructions[targetIndex].style.transition = '';
		
		// ==== Trigger animations ====
		imageTags[currentImageIndex].style.transform = goBackward ? 'translateX(100%) scale(1.01)' : 'translateX(-100%) scale(1.01)';
		imageTags[targetIndex].style.transform = 'translateX(0) scale(1.01)';
		
		instructions[currentImageIndex].style.transition = 'all 0.3s ease-in-out';
		instructions[currentImageIndex].style.transform = goBackward ? 'translateX(100%)' : 'translateX(-100%)';
		instructions[targetIndex].style.transition = 'all 0.3s ease-in-out';
		instructions[targetIndex].style.transform = 'translateX(0)';
		
		// ==== Cleanup ====
		let finished = 0;
		function onEnd(e) {
			if (e.propertyName !== 'transform') return;
			finished += 1;
			
			// Expect 4 transitions: out+in (image + instruction)
			if (finished < 4) return;
			
			// Update current index
			currentImageIndex = targetIndex;
			
			// Remove animating class to re-enable hover effects
			imageTags.forEach(img => img.classList.remove('animating'));
			
			// Update cap button states
			capButtons.forEach(btn => btn.classList.remove('active'));
			capButtons[targetIndex].classList.add('active');

			instructions[currentImageIndex].style.transition = 'none';
			instructions[targetIndex].style.transition = 'none';
			instructions[currentImageIndex].style.left = '0';
			instructions[targetIndex].style.left = '0';
			
			// Update navigation button states
			prevArrow.disabled = (currentImageIndex === 0);
			nextArrow.disabled = (currentImageIndex === imageTags.length - 1);
			
			isAnimating = false;
		}
		
		[imageTags[currentImageIndex], imageTags[targetIndex], instructions[currentImageIndex], instructions[targetIndex]].forEach(el =>
			el.addEventListener('transitionend', onEnd)
		);
	}

	const onClickCapButton = (e) => {
		const targetIndex = parseInt(e.dataset.capIndex);
		
		// Immediately update button states for instant feedback
		capButtons.forEach(btn => btn.classList.remove('active'));
		e.classList.add('active');
		
		slideToIndex(targetIndex);
	}

	const onClickNextArrow = () => {
		if (currentImageIndex < imageTags.length - 1) {
			slideToIndex(currentImageIndex + 1);
		}
	}

	const onClickPrevArrow = () => {
		if (currentImageIndex > 0) {
			slideToIndex(currentImageIndex - 1);
		}
	}


	cards.forEach((card) => {
		card.addEventListener('click', (e) => onClickGuideCard(e.currentTarget));
	});
	
	capButtons.forEach((button) => {
		button.addEventListener('click', (e) => onClickCapButton(e.currentTarget));
	});

	imageTags.forEach((image, idx) => {
		if(idx > 0) {
			image.style.transform = 'translateX(100%) scale(1.01)';
		}else{
			image.style.transform = 'translateX(0) scale(1.01)';
		}

		image.addEventListener('mouseover', (e) => {
			image.style.transform = 'translateX(0) scale(1.1)';
		});

		image.addEventListener('mouseout', (e) => {
			image.style.transform = 'translateX(0) scale(1.01)';
		});
	});
	
	if(nextArrow) {	
		nextArrow.addEventListener('click', (e) => onClickNextArrow(e.currentTarget));
	}
	if(prevArrow) {
		prevArrow.addEventListener('click', (e) => onClickPrevArrow(e.currentTarget));
	}

	if(closeSectionBtn) {
		closeSectionBtn.forEach((button) => {
			button.addEventListener('click', (e) => onClickGuideCard(e.currentTarget));
		});
	}
	
});